import { observable } from "mobx";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargePriceListItemResponse {
  /**
   * Price list item ID.
   */
  id!: string;

  /**
   * Charge type ID.
   */
  @observable
  chargeTypeId!: string;

  /**
   * Fuel type ID.
   */
  @observable
  fuelTypeId!: string;

  /**
   * Charge type price.
   */
  @observable
  price!: number;
}
